"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppropriatePlugin = void 0;
const in_clause_under_conjunction_1 = require("./in-clause-under-conjunction");
const head = require("lodash.head");
function getAppropriatePlugin(parent, queryParam, options) {
    const plugins = [
        new in_clause_under_conjunction_1.InClauseUnderConjunction(parent, queryParam, options)
    ];
    return head(plugins.filter(plugin => plugin.isMatched()));
}
exports.getAppropriatePlugin = getAppropriatePlugin;
//# sourceMappingURL=index.js.map